module.exports = __webpack_public_path__ + "img/dark-angle-angle-flipped-front.75b91e4.svg";